(function () {
    var break_point = 1200;

    var searchbar = document.querySelector(".searchbar");
    if (!searchbar) return;

    var searchInput = searchbar.querySelector("#searchbar-input");
    var closeButton = searchbar.querySelector(".searchbarClose");
    var searchForm = searchbar.querySelector("form");

    if (!searchInput || !closeButton || !searchForm) return;

    function isAboveBreakpoint() {
        return window.innerWidth > break_point;
    }

    function openSearchbar() {
        if (!isAboveBreakpoint()) return;
        searchbar.classList.add("__active");
        closeButton.removeAttribute("hidden");
    }

    function closeSearchbar() {
        searchbar.classList.remove("__active");
        closeButton.setAttribute("hidden", "true");

        // Clear input value on close
        searchInput.value = "";
    }

    // Start closed by default
    closeSearchbar();

    // Open on focus (only above breakpoint)
    searchInput.addEventListener("focus", function () {
        openSearchbar();
    });

    searchForm.addEventListener("submit", function (event) {
        if (searchInput.value.trim()) return;

        event.preventDefault();
        openSearchbar();
        searchInput.focus();
    });

    // Close on button click
    closeButton.addEventListener("click", function (event) {
        event.preventDefault();
        closeSearchbar();
        searchInput.blur();
    });

    // Close if focus moves outside the whole searchbar (tabbing past it)
    searchbar.addEventListener("focusout", function (event) {
        var nextFocusedElement = event.relatedTarget;

        // If focus is still inside searchbar, do nothing
        if (nextFocusedElement && searchbar.contains(nextFocusedElement)) return;

        closeSearchbar();
    });    

    // Close on outside click
    document.addEventListener("click", function (event) {
        if (!isAboveBreakpoint()) return;
        if (searchbar.contains(event.target)) return;

        closeSearchbar();
    });

    // Escape key closes
    searchInput.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
            closeSearchbar();
            searchInput.blur();
        }
    });

    // If user resizes below breakpoint, remove active state
    window.addEventListener("resize", function () {
        if (!isAboveBreakpoint()) {
            closeSearchbar();
        }
    });
})();
